import { decode, formatPrice, cleanseProductJson } from 'utils/general';

/**
 * This component is used throughout the site,
 * in product carousels and on the PLP page.
 */
export default {
  props: ['product', 'decode'],
  data() {
    let product;

    if (!!this.decode && this.product) {
      product = JSON.parse(decode(this.product));
      product = cleanseProductJson(product);
    } else {
      product = this.product || {
        title: '',
        price: '',
        featuredImage: '',
        variants: [],
        optionNames: [],
        optionsWithValues: {},
        reviews: {},
      };

      product = cleanseProductJson(product);
    }

    return {
      ...product,
    };
  },
  computed: {
    formattedPrice() {
      if (this.isDonateProduct || this.isGiftCard) {
        const low = this.variants[0].price;
        const high = this.variants[this.variants.length - 1].price;
        return `${formatPrice(low)} - ${formatPrice(high)}`;
      }

      let price = this.price;
      if (this.variants[0]?.compareAtPrice) {
        price = this.variants[0].compareAtPrice;
      }
      return formatPrice(price, true);
    },
    formattedDiscountPrice() {
      if (!this.variants[0] || !this.variants[0].compareAtPrice) return false;
      return formatPrice(this.price, true);
    },
  },
  methods: {
    formatPriceMethod(price) {
      return formatPrice(price);
    },
  },
  template: `
    <span
      v-text="formattedPrice"
      :aria-label="'Price: ' + formattedPrice">
    </span>
  `,
};
